module.exports = __webpack_public_path__ + "img/country1.26d9e69b.jpeg";